import React, { useState } from 'react';
import { message, Upload } from 'antd';
import { InboxOutlined, LoadingOutlined } from '@ant-design/icons';
// import './style.scss';

import UploadService from 'services/upload';
import { errHandling } from 'utils';

const PdUploader = ({
  afterUpload = () => {},
  alt = '',
  disabled = false,
  imgClassName = '',
  imgUrl = '',
  keyValue = '',
  name = '',
  purpose = 'collection',
}) => {
  const [uploading, setUploading] = useState(false);
  async function handleBeforeUpload(file) {
    try {
      setUploading(true);
      const ext = file.type.split('/')[1];
      const {
        data: { data: uploadURL },
      } = await UploadService.getUploadURL(ext, purpose);
      await UploadService.uploadImage(file, uploadURL.upload_url);
      message.success('Successfully uploaded');
      afterUpload(uploadURL.secure_url, keyValue);
    } catch (err) {
      errHandling(err);
    } finally {
      setUploading(false);
    }
  }
  return (
    <Upload.Dragger
      disabled={disabled}
      name={name}
      className="pd-uploader"
      showUploadList={false}
      beforeUpload={handleBeforeUpload}>
      {!imgUrl || uploading ? (
        <>
          <p className="ant-upload-drag-icon">
            {uploading ? <LoadingOutlined /> : <InboxOutlined />}
          </p>
          <p className="ant-upload-text">
            Click or drag a picture here to upload
          </p>
        </>
      ) : (
        <img alt={alt} className={imgClassName} src={imgUrl} />
      )}
    </Upload.Dragger>
  );
};

export default PdUploader;
